import { Route } from "react-router-dom";
import { GCP_ROUTES } from "utils/routes.constants";

import { AlreadyLinked, LinkingFailure } from "../cloudProviderLinking";

export const gcpRoutes = [
  <Route
    key={GCP_ROUTES.LINK_ALREADY_LINKED}
    path={GCP_ROUTES.LINK_ALREADY_LINKED}
    element={<AlreadyLinked />}
  />,
  <Route
    key={GCP_ROUTES.LINK_FAILURE}
    path={GCP_ROUTES.LINK_FAILURE}
    element={<LinkingFailure cloudProvider="gcp" />}
  />,
];
